import React from 'react';
import { Link } from 'react-router-dom'
import i18next from 'i18next';
class TiTroviIn extends React.Component {
    /*CLASSE IINUTILIZZATA  PER CREARE BREADCRUMB 
    -fpierantoni
    */

    render() {
        const children = this.props.children;

        return (
            <>
                <p className="breadcrumb-title">Ti trovi in:</p>
                <ol className="breadcrumb">
                    {
                        children.map((dati,index) => (
                            dati.to ?


                            <li className="breadcrumb-item" key={dati.to}>
                                
                                <Link key={dati.to} to={dati.to} aria-label={i18next.t(dati.ariaLabel)} title={i18next.t(dati.ariaLabel)}>{i18next.t(dati.label)}</Link>
                            </li> :
                                
                                <li className="breadcrumb-item" key={index}>
                                    
                                  {  dati.selected ? <strong>{i18next.t(dati.label)}</strong> : i18next.t(dati.label)}
                                </li>
                        ))
                    }
                    { this.props.title ? <li className="breadcrumb-item" key={'page'}><strong key={'page'}>{i18next.t(this.props.title)}</strong></li> : null }
                </ol>
            </>
        )
    }
}

export default TiTroviIn;